export const GET_USERS_LIST = 'GET_USERS_LIST';
export const GET_USERS_LIST_SUCCESS = 'GET_USERS_LIST_SUCCESS';
export const GET_USERS_LIST_FAIL = 'GET_USERS_LIST_FAIL';
export const GET_USERS_ON_ROLE = 'GET_USERS_ON_ROLE';
export const GET_USERS_ON_ROLE_SUCCESS = 'GET_USERS_ON_ROLE_SUCCESS';
export const GET_USERS_ON_ROLE_FAIL = 'GET_USERS_ON_ROLE_FAIL';

export const CREATE_OR_UPDATE_USER = 'CREATE_OR_UPDATE_USER';
export const CREATE_OR_UPDATE_USER_SUCCESS = 'CREATE_OR_UPDATE_USER_SUCCESS';
export const CREATE_OR_UPDATE_USER_FAIL = 'CREATE_OR_UPDATE_USER_FAIL';
export const CREATE_OR_UPDATE_USER_CLEAR = 'CREATE_OR_UPDATE_USER_CLEAR';

export const GET_ROLES_LIST = 'GET_ROLES_LIST';
export const GET_ROLES_LIST_SUCCESS = 'GET_ROLES_LIST_SUCCESS';
export const GET_ROLES_LIST_FAIL = 'GET_ROLES_LIST_FAIL';

export const CREATE_ROLE = 'CREATE_ROLE';
export const CREATE_ROLE_SUCCESS = 'CREATE_ROLE_SUCCESS';
export const CREATE_ROLE_FAIL = 'CREATE_ROLE_FAIL';
export const CREATE_ROLE_CLEAR = 'CREATE_ROLE_CLEAR';

export const UPDATE_ROLE = 'UPDATE_ROLE';
export const UPDATE_ROLE_SUCCESS = 'UPDATE_ROLE_SUCCESS';
export const UPDATE_ROLE_FAIL = 'UPDATE_ROLE_FAIL';
export const UPDATE_ROLE_CLEAR = 'UPDATE_ROLE_CLEAR';

export const GET_ROLES_ON_USER = 'GET_ROLES_ON_USER';
export const GET_ROLES_ON_USER_SUCCESS = 'GET_ROLES_ON_USER_SUCCESS';
export const GET_ROLES_ON_USER_FAIL = 'GET_ROLES_ON_USER_FAIL';

export const ADD_ROLE_ON_USER = 'ADD_ROLE_ON_USER';
export const ADD_ROLE_ON_USER_SUCCESS = 'ADD_ROLE_ON_USER_SUCCESS';
export const ADD_ROLE_ON_USER_FAIL = 'ADD_ROLE_ON_USER_FAIL';
export const ADD_ROLE_ON_USER_CLEAR = 'ADD_ROLE_ON_USER_CLEAR';

export const DELETE_ROLE_ON_USER = 'DELETE_ROLE_ON_USER';
export const DELETE_ROLE_ON_USER_SUCCESS = 'DELETE_ROLE_ON_USER_SUCCESS';
export const DELETE_ROLE_ON_USER_FAIL = 'DELETE_ROLE_ON_USER_FAIL';
export const DELETE_ROLE_ON_USER_CLEAR = 'DELETE_ROLE_ON_USER_CLEAR';

export const GET_PIECES_LIST = 'GET_PIECES_LIST';
export const GET_PIECES_LIST_SUCCESS = 'GET_PIECES_LIST_SUCCESS';
export const GET_PIECES_LIST_FAIL = 'GET_PIECES_LIST_FAIL';

export const CHANGE_PIECES_PLANT = 'CHANGE_PIECES_PLANT';
export const CHANGE_PIECES_PLANT_SUCCESS = 'CHANGE_PIECES_PLANT_SUCCESS';
export const CHANGE_PIECES_PLANT_FAIL = 'CHANGE_PIECES_PLANT_FAIL';

export const CHANGE_PIECES_STATUS = 'CHANGE_PIECES_STATUS';
export const CHANGE_PIECES_STATUS_SUCCESS = 'CHANGE_PIECES_STATUS_SUCCESS';
export const CHANGE_PIECES_STATUS_FAIL = 'CHANGE_PIECES_STATUS_FAIL';

export const GET_STATUSES_LIST = 'GET_STATUSES_LIST';
export const GET_STATUSES_LIST_SUCCESS = 'GET_STATUSES_LIST_SUCCESS';
export const GET_STATUSES_LIST_FAIL = 'GET_STATUSES_LIST_FAIL';

export const PLANT_VISIT = 'PLANT_VISIT';

export const GET_VISITS_USER = 'GET_VISITS_USER';
export const GET_VISITS_USER_SUCCESS = 'GET_VISITS_USER_SUCCESS';
export const GET_VISITS_USER_FAIL = 'GET_VISITS_USER_FAIL';
export const GET_VISITS_USER_CLEAR = 'GET_VISITS_USER_CLEAR';

export const GET_PERMISSIONS_ON_ROLE = 'GET_PERMISSIONS_ON_ROLE';
export const GET_PERMISSIONS_ON_ROLE_SUCCESS = 'GET_PERMISSIONS_ON_ROLE_SUCCESS';
export const GET_PERMISSIONS_ON_ROLE_FAIL = 'GET_PERMISSIONS_ON_ROLE_FAIL';

export const GET_PERMISSIONS = 'GET_PERMISSIONS';
export const GET_PERMISSIONS_SUCCESS = 'GET_PERMISSIONS_SUCCESS';
export const GET_PERMISSIONS_FAIL = 'GET_PERMISSIONS_FAIL';

export const GET_PERMISSION_VALUES = 'GET_PERMISSION_VALUES';
export const GET_PERMISSION_VALUES_SUCCESS = 'GET_PERMISSION_VALUES_SUCCESS';
export const GET_PERMISSION_VALUES_FAIL = 'GET_PERMISSION_VALUES_FAIL';

export const ADD_PERMISSION_ON_ROLE = 'ADD_ROLE_ON_ROLE';
export const ADD_PERMISSION_ON_ROLE_SUCCESS = 'ADD_ROLE_ON_ROLE_SUCCESS';
export const ADD_PERMISSION_ON_ROLE_FAIL = 'ADD_ROLE_ON_ROLE_FAIL';
export const ADD_PERMISSION_ON_ROLE_CLEAR = 'ADD_ROLE_ON_ROLE_CLEAR';

export const DELETE_PERMISSION_ON_ROLE = 'DELETE_PERMISSION_ON_ROLE';
export const DELETE_PERMISSION_ON_ROLE_SUCCESS = 'DELETE_PERMISSION_ON_ROLE_SUCCESS';
export const DELETE_PERMISSION_ON_ROLE_FAIL = 'DELETE_PERMISSION_ON_ROLE_FAIL';
export const DELETE_PERMISSION_ON_ROLE_CLEAR = 'DELETE_PERMISSION_ON_ROLE_CLEAR';
